<template>
    <div>
       <div class="shaoguan">
           <h1>韶关市危房监测项目</h1>
           <div class="sgproject column">
               <div class="basic_title row">
              <div class="axis"></div>
              <h6>项目背景</h6>
           </div>
           <p>广东省韶关市某县村民在没有任何审批手续的情况下私自在自家山地建房，山体的开挖改变了山上民房基础挡土墙的受力情况，导致挡土墙开裂，部分房屋也出现开裂现象，严重<br>威胁居民的生命财产安全。当地政府部门得知情况后，立即安排居民撤离，并组织工程队伍加固挡土墙 </p>
           <p>现场情况如下图： </p>
           <img src="../../assets/shao/1.jpg" alt="">
           <img src="../../assets/shao/2.jpg" alt="">
           <img src="../../assets/shao/3.jpg" alt="">
               <div class="basic_title row">
              <div class="axis"></div>
              <h6>监测内容</h6>
           </div>
           <span> &nbsp（1）山体上部居民区地基挡土墙变形监测 </span>
           <p>这一部分我们采用RocMos自动化监测系统+拓普康DS测量机器人进行表面位移监测。 </p>
           <span>监测过程： </span>
           <p>在挡土墙和出现明显开裂的房屋房顶布设共计19个监测点，在监测区域外稳定地段的房顶架站并布设了三个控制点。全站仪安装完成后，通过串口线接入RocBox终端，RocBox终<br>端控制全站仪采集数据，我们可通过RocMos软件控制RocBox终端对参数进行设置，更改监测周期等。可依据不同项目，不同情况来进行设置，满足多方面需求。也可通过远程控<br>制加测数据，以面对紧急情况。采集好的数据通过4G网络可以实时传输到服务器上。随时了解现场监测情况。RocBox监测终端能接入多种类型传感器，如振弦式传感器：渗压计，<br>应变计，单点位移计，位错计等。通过这些传感器的接入能完成渗压，内部变形，应力应变等其它方面的监测工作。 </p>
           <img src="../../assets/shao/4.jpg" alt="">
           <p>由于项目时间紧，任务重，观测频率被设置为每30分钟观测一次。每一观测周期的监测数据均会传输到监测软件进行数据分析，监测云平台能够输出多种格式的监测报表上报<br>给政府部门。</p>
           <p>提交的报表见下图： </p>
           <img src="../../assets/shao/5.jpg" alt="">
           <span>^&nbsp（2） 山体下部的挡土墙变形监测 </span>
           <p>这一部分我们采用RocMos自动化监测系统+拓普康DS测量机器人进行表面位移监测。 </p>
           <span>监测过程： </span>
           <p>在挡土墙和出现明显开裂的房屋房顶布设共计19个监测点，在监测区域外稳定地段的房顶架站并布设了三个控制点。全站仪安装完成后，通过串口线接入RocBox终端，RocBox终<br>端控制全站仪采集数据，我们可通过RocMos软件控制RocBox终端对参数进行设置，更改监测周期等。可依据不同项目，不同情况来进行设置，满足多方面需求。也可通过远程控<br>制加测数据，以面对紧急情况。采集好的数据通过4G网络可以实时传输到服务器上。随时了解现场监测情况。RocBox监测终端能接入多种类型传感器，如振弦式传感器：渗压计，<br>应变计，单点位移计，位错计等。通过这些传感器的接入能完成渗压，内部变形，应力应变等其它方面的监测工作。 </p>
           <img src="../../assets/shao/6.jpg" alt="">
           <p>采集平台静力水准的数据查看如下图： </p>
           <img src="../../assets/shao/7.jpg" alt="">
               <div class="basic_title row">
              <div class="axis"></div>
              <h6>项目小结</h6>
           </div>
           <p>历时两个多月，本次韶关市仁化县莲塘尾村危房监测项目圆满完成。该项目运用了岩蚁RocMos自动化监测系统，并结合了最新研发的岩蚁监测物联网技术，从而达到了在条件苛刻的监测环境中仍然严格保证监测精度的要求，更好的解决客户遇到的监测难题</p>
           <p> 岩石科技将继续更新产品，努力为广大用户提供自动化监测领域更好的解决方案.</p>

           </div>
       </div>
       <foot></foot>
    </div>
</template>

<style>
.shaoguan {
  width: 100%;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
}
.shaoguan .sgproject {
  width: 11.2rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  margin-bottom: 0.67rem;
}
.shaoguan h1 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
  text-align: center;
}
.sgproject .basic_title {
  margin-top: 0.34rem;
  margin-bottom: 0.04rem;
}
.sgproject .axis {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
.sgproject h6 {
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(37, 43, 58, 1);
}
.sgproject p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-top: 0.1rem;
}
.sgproject img {
  width: 4.52rem;
  margin-top: 0.2rem;
}
.sgproject span{
    color: #252B3A;
    font-weight: bold;
    font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  padding-top: 0.1rem;
}
.sgproject p:last-child{
    padding-bottom: .51rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>


// WEBPACK FOOTER //
// src/homepages/casepage/shaoguan.vue